module.exports = __webpack_public_path__ + "static/media/Q_8.59470d2e.jpg";